<template>
  <div
    :style="`width: ${width}px; height: ${height}px;`"
    :class="[bg, { 'm-auto': center }, { 'rounded-circle': circle }]"
  >
    <b-img
      fluid
      :class="`bg-${color}`"
      v-if="customSvgColor"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA
           AEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII="
      :style="{ ...customStyle, maskImage: 'url(' + iconImage + ')' }"
    >
    </b-img>
    <b-img v-else fluid :src="iconImage" :width="width" :height="height"></b-img>
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    },
    circle: {
      type: Boolean,
      default: true
    },
    bg: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'white'
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customStyle() {
      return {
        display: 'block',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'cover',
        margin: 'auto',
        width: this.width.toString().concat('px'),
        height: this.height.toString().concat('px')
      }
    },
    customSvgColor() {
      return this.color !== 'initial'
    },
    iconImage() {
      return new URL(`/src/assets/svg/${this.icon}.svg`, import.meta.url).href
    }
  }
}
</script>
